import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotificationsService} from './notifications.service';
import {ChatNotifFacadeService} from './chat-notif-facade.service';
import {NbMenuModule} from '@nebular/theme';
import {
  ChatMessageAdapter,
  ChatNotificationAdapter,
  ChatMessageRecipientAdapter,
  AlertNotifAdapter,
  NotificationAdapter,
} from './adapters';

@NgModule({
  declarations: [],
  providers: [
    NotificationsService,
    ChatNotifFacadeService,
    ChatMessageAdapter,
    ChatNotificationAdapter,
    ChatMessageRecipientAdapter,
    AlertNotifAdapter,
    NotificationAdapter,
  ],
  imports: [CommonModule, NbMenuModule],
})
export class NotificationModule {}
